<template>
  <transition name="dataClear">
    <div class="bl_modalBlock">
      <div class="bl_modalContent">

        <div class="bl_modalTxtBlock">
          <p>これまでの<br class="spBlock">きろくをけして<br>はじめから<br class="spBlock">スタートしますか？</p>
        </div>

        <div class="bl_btnBlock">
          <a class="el_btn" @click="dataClear()">はい</a>
          <a class="el_btn" @click="close()">いいえ</a>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'DataClear',
  computed: {
    ...mapState('odakyuQuizClearData', [
      'clearData',
    ]),
    ...mapState('odakyuQuizLoadData', [
      'loadData',
    ]),
  },
  created() {
    if (this.loadData.grade <= 0 && this.clearData.grade <= 0) {
      this.setQuestionNum();
      this.$store.commit('currentPage/changeCurrentPage', 'selectGrade');
    }
  },
  methods: {
    dataClear() {
      const loadData = {
        grade: 0,
        stage: 0,
        question: 0,
      };
      this.$store.commit('odakyuQuizClearData/changeGrade', 0);
      this.$store.commit('odakyuQuizClearData/changeStage', 0);
      this.$store.commit('odakyuQuizLoadData/saveLoadData', loadData);
      this.$store.commit('currentPage/changeCurrentPage', 'selectGrade');
      this.setQuestionNum();
    },
    close() {
      this.$emit('close');
    },
    setQuestionNum() {
      const questionNumArr = [];
      const stageQuestionNumArr = [];
      const gradeQuestionNumArr = [];
      let randomNum = '';
      for (let i = 0; i < 5; i += 1) {
        for (let j = 0; j < 20; j += 1) {
          while (true) {
            randomNum = Math.floor(Math.random() * 20);
            if (!stageQuestionNumArr.includes(randomNum)) {
              stageQuestionNumArr.push(randomNum);
              break;
            }
          }
        }
        for (let j = 0; j < 4; j += 1) {
          gradeQuestionNumArr.push(stageQuestionNumArr.splice(0, 5));
        }
        questionNumArr.push(gradeQuestionNumArr.splice(0, 4));
      }
      this.$store.commit('odakyuQuizQuestionNumArr/changeQuestionNumArr', questionNumArr);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.bl_modalBlock {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  transition: opacity 2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bl_modalContent {
  width: 60%;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 10px;
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.bl_modalTxtBlock{
  text-align: center;
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 15px;
}

.bl_btnBlock{
  display: flex;
  justify-content: center;
  align-items: center;

  .el_btn{
    margin-right: 10px;
    max-width: 325px;

    &:last-of-type{
      margin-right: 0;
    }
  }
}

@media screen and (max-width: 768px){
  .bl_modalTxtBlock{
    font-size: 22px;
  }

  .bl_btnBlock{
    flex-direction: column;

    .el_btn{
      margin-right: 0;
      margin-bottom: 10px;

      &:last-of-type{
        margin-bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DataClear.vue